import { FillableModel } from './fillable.model';

export class PaymentGatewayModel extends FillableModel {
    public id: number;
    public name: string;
    public cards_allowed_number = 1;
    public tokenization_allowed = true;
    public publishable_key = '';

    /**
     * This receive a json and populate this object using this json
     */
    public fillConfigurations(configurations: any): void {
        configurations.forEach(configuration => {
            let key = configuration.key.replace('-', '_');
            let value = configuration.value;

            if (key === 'tokenization_allowed') {
                value = value === '1';
            }
            if (key === 'cards_allowed_number') {
                value = parseInt(value);
            }

            this[key] = value;
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/shared/models/payment-gateway.model.ts